import { Component } from '@theme/component';
import { sectionRenderer } from '@theme/section-renderer';
import { ThemeEvents } from '@theme/events';

/**
 * Paginated list with classic page navigation (no infinite scroll).
 * Infinite scroll is disabled for better page speed and SEO.
 */
export default class PaginatedList extends Component {
  pages = new Map();
  infinityScrollObserver = undefined;
  #imageRatioSetting = null;

  connectedCallback() {
    super.connectedCallback();
    this.#storeImageRatioSettings();
    // Infinite scroll intentionally disabled — using classic pagination instead
    document.addEventListener(ThemeEvents.FilterUpdate, this.#handleFilterUpdate);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(ThemeEvents.FilterUpdate, this.#handleFilterUpdate);
  }

  #storeImageRatioSettings() {
    const firstCardGallery = this.querySelector('[ref="cardGallery"]');
    if (!firstCardGallery) return;
    this.#imageRatioSetting = firstCardGallery.getAttribute('data-image-ratio');
  }

  get sectionId() {
    const id = this.getAttribute('section-id');
    if (!id) throw new Error('The section-id attribute is required');
    return id;
  }

  #handleFilterUpdate = () => {
    this.pages.clear();
  };

  static ASPECT_RATIOS = {
    square: '1',
    portrait: '0.8',
    landscape: '1.778',
  };
}
